import { TableHead } from '@/components/Datatable/TableHead';
import { SortableTableHeadersProps } from '@/type/listing.types';

export const VehiculeTableHeaders = ({
  t,
  onSort,
}: SortableTableHeadersProps) => {
  return (
    <>
      <TableHead
        text={`${t('common:licensePlateNumber')} & ${t('common:vin')}`}
        thClassName="w-[230px]"
        sortable
        onSortClick={() => onSort?.('licensePlateAndVin')}
      />
      {/* <TableHead text={t('common:brand')} thClassName="min-w-[150px]" />
      <TableHead text={t('common:model')} thClassName="min-w-[150px]" /> */}
      <TableHead
        text={`${t('common:brand')} & ${t('common:model')}`}
        thClassName="min-w-[220px]"
        sortable
        onSortClick={() => onSort?.('brandAndModel')}
      />
      <TableHead
        text={t('common:year')}
        thClassName="text-center min-w-0 w-0"
        sortable
        onSortClick={() => onSort?.('yearOfFirstRegistration')}
      />
      <TableHead text={t('awaitingInspection')} thClassName="min-w-0 w-0" />
      <TableHead
        text={t('common:lastInspection')}
        thClassName="min-w-[191px]"
      />
      <TableHead
        text={t('common:status')}
        thClassName="text-center min-w-0 w-0"
      />
      <TableHead text={t('common:inspections')} thClassName="min-w-0 w-0" />
      <TableHead thClassName="sticky-action-column" />
    </>
  );
};
